// // src/components/payment/MonerisLiveTrainingCheckoutPage.jsx
// import React, { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { Button, Spin, message, Result } from "antd";
// import {
//     ArrowLeftOutlined,
//     VideoCameraOutlined,
//     CheckCircleOutlined,
//     CalendarOutlined,
//     ClockCircleOutlined,
//     DollarOutlined,
//     UserOutlined,
//     MailOutlined,
//     TagsOutlined,
//     SafetyCertificateOutlined,
//     GiftOutlined,
//     LockOutlined,
// } from "@ant-design/icons";
// import dayjs from "dayjs";
// import liveTrainingService from "../../services/liveTraining.service";
// import MonerisPaymentLiveTraining from "./MonerisPaymentLiveTraining";

// const MonerisLiveTrainingCheckoutPage = () => {
//     const { id } = useParams();
//     const navigate = useNavigate();
//     const { user: currentUser } = useSelector((state) => state.auth);

//     const [training, setTraining] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [paymentSuccess, setPaymentSuccess] = useState(false);

//     useEffect(() => {
//         if (!currentUser) {
//             message.warning("Veuillez vous connecter pour acceder au paiement");
//             navigate(`/login`);
//             return;
//         }

//         const fetchTraining = async () => {
//             try {
//                 setLoading(true);
//                 const data = await liveTrainingService.getById(id);
//                 setTraining(data);

//                 const checkResult = await liveTrainingService.checkPurchase(currentUser.id, id);
//                 if (checkResult.hasPurchased) {
//                     message.info("Vous etes deja inscrit a cette formation !");
//                     navigate(`/live-training/${id}`);
//                     return;
//                 }
//             } catch (error) {
//                 console.error("Erreur:", error);
//                 message.error("Formation introuvable");
//                 navigate("/live-trainings");
//             } finally {
//                 setLoading(false);
//             }
//         };

//         if (id) fetchTraining();
//     }, [id, navigate, currentUser]);

//     const handleSuccess = ({ purchase }) => {
//         console.log("Paiement reussi !", purchase);
//         setPaymentSuccess(true);
//         setTimeout(() => {
//             navigate(`/live-training/${id}`);
//         }, 3000);
//     };

//     const handleError = (error) => {
//         console.error("Erreur paiement:", error);
//     };

//     const formatDate = (date) => {
//         if (!date) return "Date a venir";
//         return dayjs(date).format("dddd DD MMMM YYYY HH:mm");
//     };

//     const getTimeUntil = (date) => {
//         if (!date) return null;
//         const target = dayjs(date);
//         const now = dayjs();
//         if (target.isBefore(now)) return null;
//         const days = target.diff(now, "day");
//         const hours = target.diff(now, "hour") % 24;
//         return { days, hours };
//     };

//     if (loading) {
//         return (
//             <div style={{
//                 minHeight: '70vh',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 background: '#f8f9fa'
//             }}>
//                 <Spin size="large" tip="Chargement..." />
//             </div>
//         );
//     }

//     if (!training) return null;

//     if (paymentSuccess) {
//         return (
//             <div style={{
//                 minHeight: '80vh',
//                 background: '#f8f9fa',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 padding: 20,
//             }}>
//                 <div style={{
//                     background: 'white',
//                     borderRadius: 20,
//                     padding: 40,
//                     maxWidth: 600,
//                     textAlign: 'center',
//                     boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
//                 }}>
//                     <Result
//                         status="success"
//                         title="Paiement reussi !"
//                         subTitle={
//                             <div>
//                                 <p>Vous etes maintenant inscrit a la formation :</p>
//                                 <p style={{ fontWeight: 700, color: '#1a1a1a', fontSize: 18 }}>
//                                     {training.title}
//                                 </p>
//                                 <p style={{ color: '#6b7280', fontSize: 14, marginTop: 16 }}>
//                                     Un email de confirmation avec le lien de la session a ete envoye.
//                                 </p>
//                                 <p style={{ color: '#9ca3af', fontSize: 13, marginTop: 12 }}>
//                                     Redirection en cours...
//                                 </p>
//                             </div>
//                         }
//                         extra={
//                             <Button
//                                 type="primary"
//                                 size="large"
//                                 onClick={() => navigate(`/live-training/${id}`)}
//                                 style={{
//                                     background: 'linear-gradient(135deg, #ee5a6f 0%, #ff6b6b 100%)',
//                                     border: 'none',
//                                     fontWeight: 600,
//                                 }}
//                             >
//                                 Voir ma formation
//                             </Button>
//                         }
//                     />
//                 </div>
//             </div>
//         );
//     }

//     const timeUntil = getTimeUntil(training.liveDate);

//     return (
//         <div style={{
//             minHeight: '100vh',
//             background: '#f8f9fa',
//             padding: '24px 16px',
//         }}>
//             <div style={{
//                 maxWidth: 1300,
//                 margin: '0 auto',
//             }}>
//                 <Button
//                     icon={<ArrowLeftOutlined />}
//                     onClick={() => navigate(`/live-training/${id}`)}
//                     size="large"
//                     style={{ marginBottom: 24 }}
//                 >
//                     Retour a la formation
//                 </Button>

//                 {/* Header rouge */}
//                 <div style={{
//                     background: 'linear-gradient(135deg, #ee5a6f 0%, #ff6b6b 100%)',
//                     borderRadius: 20,
//                     padding: '32px',
//                     color: 'white',
//                     marginBottom: 24,
//                     boxShadow: '0 8px 24px rgba(238,90,111,0.2)',
//                 }}>
//                     <div style={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: 16,
//                         marginBottom: 16,
//                     }}>
//                         <div style={{
//                             background: 'rgba(255,255,255,0.2)',
//                             borderRadius: 12,
//                             padding: 12,
//                             fontSize: 32,
//                         }}>
//                             <VideoCameraOutlined />
//                         </div>
//                         <div style={{ flex: 1 }}>
//                             <div style={{
//                                 fontSize: 13,
//                                 opacity: 0.9,
//                                 fontWeight: 600,
//                                 textTransform: 'uppercase',
//                                 letterSpacing: 1.5,
//                             }}>
//                                 Inscription Formation Live
//                             </div>
//                             <h1 style={{
//                                 margin: '4px 0 0 0',
//                                 fontSize: 28,
//                                 fontWeight: 800,
//                             }}>
//                                 {training.title}
//                             </h1>
//                         </div>

//                         {/* Compte a rebours dans le header */}
//                         {timeUntil && (
//                             <div style={{
//                                 background: 'rgba(255,255,255,0.15)',
//                                 backdropFilter: 'blur(10px)',
//                                 padding: '12px 20px',
//                                 borderRadius: 12,
//                                 textAlign: 'center',
//                                 border: '1px solid rgba(255,255,255,0.2)',
//                             }}>
//                                 <div style={{ fontSize: 11, opacity: 0.9, fontWeight: 600 }}>
//                                     DEMARRAGE DANS
//                                 </div>
//                                 <div style={{ fontSize: 22, fontWeight: 800, marginTop: 4 }}>
//                                     {timeUntil.days}j {timeUntil.hours}h
//                                 </div>
//                             </div>
//                         )}
//                     </div>

//                     <div style={{
//                         display: 'flex',
//                         gap: 24,
//                         flexWrap: 'wrap',
//                         marginTop: 20,
//                         paddingTop: 20,
//                         borderTop: '1px solid rgba(255,255,255,0.2)',
//                     }}>
//                         <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
//                             <CalendarOutlined />
//                             <span>{formatDate(training.liveDate)}</span>
//                         </div>
//                         {training.duration && (
//                             <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
//                                 <ClockCircleOutlined />
//                                 <span>Duree : {training.duration}</span>
//                             </div>
//                         )}
//                         <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
//                             <DollarOutlined />
//                             <span style={{ fontWeight: 700, fontSize: 18 }}>
//                                 {training.price?.toFixed(2)} $ CAD
//                             </span>
//                         </div>
//                     </div>
//                 </div>

//                 {/* GRID 2 colonnes : Paiement + Sidebar */}
//                 <div style={{
//                     display: 'grid',
//                     gridTemplateColumns: '1fr 380px',
//                     gap: 24,
//                 }}
//                     className="checkout-grid"
//                 >
//                     {/* COLONNE 1 : Composant de paiement */}
//                     <div>
//                         <div style={{
//                             background: 'white',
//                             borderRadius: 16,
//                             padding: 24,
//                             boxShadow: '0 4px 16px rgba(0,0,0,0.05)',
//                         }}>
//                             <MonerisPaymentLiveTraining
//                                 liveTraining={training}
//                                 onSuccess={handleSuccess}
//                                 onError={handleError}
//                             />
//                         </div>
//                     </div>

//                     {/* COLONNE 2 : Sidebar avec infos */}
//                     <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>

//                         {/* Récap commande */}
//                         <div style={{
//                             background: 'white',
//                             borderRadius: 16,
//                             padding: 24,
//                             boxShadow: '0 4px 16px rgba(0,0,0,0.05)',
//                             border: '1px solid #f0f0f0',
//                         }}>
//                             <h3 style={{
//                                 fontSize: 12,
//                                 color: '#6b7280',
//                                 textTransform: 'uppercase',
//                                 letterSpacing: 1,
//                                 fontWeight: 600,
//                                 margin: '0 0 16px',
//                             }}>
//                                 📋 Recapitulatif de commande
//                             </h3>

//                             {training.image && (
//                                 <img
//                                     src={training.image}
//                                     alt={training.title}
//                                     style={{
//                                         width: '100%',
//                                         height: 140,
//                                         objectFit: 'cover',
//                                         borderRadius: 10,
//                                         marginBottom: 16,
//                                     }}
//                                 />
//                             )}

//                             <div style={{
//                                 display: 'flex',
//                                 justifyContent: 'space-between',
//                                 padding: '8px 0',
//                                 borderBottom: '1px solid #f0f0f0',
//                                 fontSize: 14,
//                             }}>
//                                 <span style={{ color: '#6b7280' }}>Formation :</span>
//                                 <span style={{
//                                     fontWeight: 600,
//                                     maxWidth: 200,
//                                     textOverflow: 'ellipsis',
//                                     overflow: 'hidden',
//                                     whiteSpace: 'nowrap',
//                                 }}>
//                                     {training.title}
//                                 </span>
//                             </div>

//                             <div style={{
//                                 display: 'flex',
//                                 justifyContent: 'space-between',
//                                 padding: '8px 0',
//                                 borderBottom: '1px solid #f0f0f0',
//                                 fontSize: 14,
//                             }}>
//                                 <span style={{ color: '#6b7280' }}>Date :</span>
//                                 <span style={{ fontWeight: 600, textAlign: 'right' }}>
//                                     {dayjs(training.liveDate).format('DD/MM/YYYY HH:mm')}
//                                 </span>
//                             </div>

//                             {training.duration && (
//                                 <div style={{
//                                     display: 'flex',
//                                     justifyContent: 'space-between',
//                                     padding: '8px 0',
//                                     borderBottom: '1px solid #f0f0f0',
//                                     fontSize: 14,
//                                 }}>
//                                     <span style={{ color: '#6b7280' }}>Duree :</span>
//                                     <span style={{ fontWeight: 600 }}>{training.duration}</span>
//                                 </div>
//                             )}

//                             {training.category?.libelle && (
//                                 <div style={{
//                                     display: 'flex',
//                                     justifyContent: 'space-between',
//                                     padding: '8px 0',
//                                     borderBottom: '1px solid #f0f0f0',
//                                     fontSize: 14,
//                                 }}>
//                                     <span style={{ color: '#6b7280' }}>Categorie :</span>
//                                     <span style={{ fontWeight: 600 }}>{training.category.libelle}</span>
//                                 </div>
//                             )}

//                             <div style={{
//                                 display: 'flex',
//                                 justifyContent: 'space-between',
//                                 alignItems: 'center',
//                                 padding: '16px 0 8px',
//                                 marginTop: 8,
//                                 borderTop: '2px solid #ee5a6f',
//                             }}>
//                                 <span style={{ fontSize: 16, fontWeight: 700 }}>Total :</span>
//                                 <span style={{
//                                     color: '#ee5a6f',
//                                     fontWeight: 800,
//                                     fontSize: 26,
//                                 }}>
//                                     {training.price?.toFixed(2)} $ CAD
//                                 </span>
//                             </div>
//                         </div>

//                         {/* Vos informations */}
//                         <div style={{
//                             background: 'white',
//                             borderRadius: 16,
//                             padding: 24,
//                             boxShadow: '0 4px 16px rgba(0,0,0,0.05)',
//                             border: '1px solid #f0f0f0',
//                         }}>
//                             <h3 style={{
//                                 fontSize: 12,
//                                 color: '#6b7280',
//                                 textTransform: 'uppercase',
//                                 letterSpacing: 1,
//                                 fontWeight: 600,
//                                 margin: '0 0 16px',
//                             }}>
//                                 👤 Vos informations
//                             </h3>

//                             <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
//                                 <UserOutlined style={{ color: '#ee5a6f', fontSize: 16 }} />
//                                 <div>
//                                     <div style={{ fontSize: 11, color: '#9ca3af', textTransform: 'uppercase' }}>
//                                         Utilisateur
//                                     </div>
//                                     <div style={{ fontWeight: 600 }}>{currentUser?.username}</div>
//                                 </div>
//                             </div>

//                             <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
//                                 <MailOutlined style={{ color: '#ee5a6f', fontSize: 16 }} />
//                                 <div>
//                                     <div style={{ fontSize: 11, color: '#9ca3af', textTransform: 'uppercase' }}>
//                                         Email de contact
//                                     </div>
//                                     <div style={{ fontWeight: 600, fontSize: 13 }}>{currentUser?.email}</div>
//                                 </div>
//                             </div>
//                         </div>

//                         {/* Avantages inclus */}
//                         <div style={{
//                             background: 'linear-gradient(135deg, #fff5f5 0%, #ffe5e8 100%)',
//                             borderRadius: 16,
//                             padding: 24,
//                             border: '1px solid #ffd1d6',
//                         }}>
//                             <h3 style={{
//                                 fontSize: 12,
//                                 color: '#ee5a6f',
//                                 textTransform: 'uppercase',
//                                 letterSpacing: 1,
//                                 fontWeight: 700,
//                                 margin: '0 0 16px',
//                             }}>
//                                 <GiftOutlined /> Avantages inclus
//                             </h3>

//                             <ul style={{
//                                 listStyle: 'none',
//                                 padding: 0,
//                                 margin: 0,
//                                 display: 'flex',
//                                 flexDirection: 'column',
//                                 gap: 10,
//                             }}>
//                                 <li style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13, color: '#1a1a1a' }}>
//                                     <CheckCircleOutlined style={{ color: '#10b981', fontSize: 16, marginTop: 2 }} />
//                                     <span>Session live interactive avec le formateur</span>
//                                 </li>
//                                 <li style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13, color: '#1a1a1a' }}>
//                                     <CheckCircleOutlined style={{ color: '#10b981', fontSize: 16, marginTop: 2 }} />
//                                     <span>Q&A en direct pour poser vos questions</span>
//                                 </li>
//                                 <li style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13, color: '#1a1a1a' }}>
//                                     <CheckCircleOutlined style={{ color: '#10b981', fontSize: 16, marginTop: 2 }} />
//                                     <span>Lien meeting envoye par email</span>
//                                 </li>
//                                 <li style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13, color: '#1a1a1a' }}>
//                                     <CheckCircleOutlined style={{ color: '#10b981', fontSize: 16, marginTop: 2 }} />
//                                     <span>Rappels automatiques avant le live</span>
//                                 </li>
//                                 <li style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13, color: '#1a1a1a' }}>
//                                     <CheckCircleOutlined style={{ color: '#10b981', fontSize: 16, marginTop: 2 }} />
//                                     <span>Replay disponible apres la session</span>
//                                 </li>
//                                 <li style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13, color: '#1a1a1a' }}>
//                                     <CheckCircleOutlined style={{ color: '#10b981', fontSize: 16, marginTop: 2 }} />
//                                     <span>Support du formateur 7 jours</span>
//                                 </li>
//                             </ul>
//                         </div>

//                         {/* Garanties de sécurité */}
//                         <div style={{
//                             background: 'white',
//                             borderRadius: 16,
//                             padding: 20,
//                             border: '1px solid #f0f0f0',
//                             boxShadow: '0 4px 16px rgba(0,0,0,0.05)',
//                         }}>
//                             <h3 style={{
//                                 fontSize: 12,
//                                 color: '#6b7280',
//                                 textTransform: 'uppercase',
//                                 letterSpacing: 1,
//                                 fontWeight: 600,
//                                 margin: '0 0 16px',
//                             }}>
//                                 🛡️ Paiement securise
//                             </h3>

//                             <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
//                                 <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
//                                     <LockOutlined style={{ color: '#10b981', fontSize: 18 }} />
//                                     <div style={{ fontSize: 13 }}>
//                                         <strong>Chiffrement SSL/TLS</strong>
//                                         <div style={{ fontSize: 11, color: '#9ca3af' }}>
//                                             Vos donnees sont protegees
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
//                                     <SafetyCertificateOutlined style={{ color: '#10b981', fontSize: 18 }} />
//                                     <div style={{ fontSize: 13 }}>
//                                         <strong>Norme PCI-DSS</strong>
//                                         <div style={{ fontSize: 11, color: '#9ca3af' }}>
//                                             Standard bancaire
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
//                                     <CheckCircleOutlined style={{ color: '#10b981', fontSize: 18 }} />
//                                     <div style={{ fontSize: 13 }}>
//                                         <strong>Powered by Moneris</strong>
//                                         <div style={{ fontSize: 11, color: '#9ca3af' }}>
//                                             Leader canadien
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         {/* Aide */}
//                         <div style={{
//                             background: '#f0f7ff',
//                             border: '1px solid #91d5ff',
//                             borderRadius: 12,
//                             padding: 16,
//                             textAlign: 'center',
//                         }}>
//                             <div style={{ fontSize: 12, color: '#0050b3', fontWeight: 600, marginBottom: 4 }}>
//                                 💬 Besoin d'aide ?
//                             </div>
//                             <div style={{ fontSize: 13, color: '#1a1a1a', fontWeight: 700 }}>
//                                 +212 661 571 360
//                             </div>
//                             <div style={{ fontSize: 11, color: '#6b7280', marginTop: 4 }}>
//                                 Disponible 7j/7
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Footer */}
//                 <div style={{
//                     textAlign: 'center',
//                     marginTop: 32,
//                     color: '#6b7280',
//                     fontSize: 13,
//                 }}>
//                     <CheckCircleOutlined style={{ color: '#10b981', marginRight: 6 }} />
//                     Paiement 100% securise par Moneris
//                 </div>

//                 {/* Style responsive */}
//                 <style>{`
//                     @media (max-width: 1024px) {
//                         .checkout-grid {
//                             grid-template-columns: 1fr !important;
//                         }
//                     }
//                 `}</style>
//             </div>
//         </div>
//     );
// };

// export default MonerisLiveTrainingCheckoutPage;


// src/components/payment/MonerisLiveTrainingCheckoutPage.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Button, Spin, message, Result } from "antd";
import {
    ArrowLeftOutlined,
    VideoCameraOutlined,
    CheckCircleOutlined,
    CalendarOutlined,
    ClockCircleOutlined,
    DollarOutlined,
    UserOutlined,
    MailOutlined,
    TagsOutlined,
    SafetyCertificateOutlined,
    GiftOutlined,
    LockOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import liveTrainingService from "../../services/liveTraining.service";
import MonerisPaymentLiveTraining from "./MonerisPaymentLiveTraining";

// 🎨 COULEURS NOMIDYA
const C = {
    blue: "#0054A6",
    blueDark: "#003B75",
    blueDeep: "#002147",
    orange: "#E8860C",
    orangeLight: "#FF8C00",
    orangeDark: "#C46F0A",
};

const MonerisLiveTrainingCheckoutPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { user: currentUser } = useSelector((state) => state.auth);

    const [training, setTraining] = useState(null);
    const [loading, setLoading] = useState(true);
    const [paymentSuccess, setPaymentSuccess] = useState(false);

    useEffect(() => {
        if (!currentUser) {
            message.warning("Veuillez vous connecter pour acceder au paiement");
            navigate(`/login`);
            return;
        }

        const fetchTraining = async () => {
            try {
                setLoading(true);
                const data = await liveTrainingService.getById(id);
                setTraining(data);

                const checkResult = await liveTrainingService.checkPurchase(currentUser.id, id);
                if (checkResult.hasPurchased) {
                    message.info("Vous etes deja inscrit a cette formation !");
                    navigate(`/live-training/${id}`);
                    return;
                }
            } catch (error) {
                console.error("Erreur:", error);
                message.error("Formation introuvable");
                navigate("/live-trainings");
            } finally {
                setLoading(false);
            }
        };

        if (id) fetchTraining();
    }, [id, navigate, currentUser]);

    const handleSuccess = ({ purchase }) => {
        console.log("Paiement reussi !", purchase);
        setPaymentSuccess(true);
        setTimeout(() => {
            navigate(`/live-training/${id}`);
        }, 3000);
    };

    const handleError = (error) => {
        console.error("Erreur paiement:", error);
    };

    const formatDate = (date) => {
        if (!date) return "Date a venir";
        return dayjs(date).format("dddd DD MMMM YYYY HH:mm");
    };

    const getTimeUntil = (date) => {
        if (!date) return null;
        const target = dayjs(date);
        const now = dayjs();
        if (target.isBefore(now)) return null;
        const days = target.diff(now, "day");
        const hours = target.diff(now, "hour") % 24;
        return { days, hours };
    };

    if (loading) {
        return (
            <div style={{
                minHeight: '70vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: '#f8f9fa'
            }}>
                <Spin size="large" tip="Chargement..." />
            </div>
        );
    }

    if (!training) return null;

    if (paymentSuccess) {
        return (
            <div style={{
                minHeight: '80vh',
                background: '#f8f9fa',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 20,
            }}>
                <div style={{
                    background: 'white',
                    borderRadius: 20,
                    padding: 40,
                    maxWidth: 600,
                    textAlign: 'center',
                    boxShadow: '0 10px 40px rgba(0,84,166,0.15)',
                    border: `2px solid ${C.blue}22`,
                }}>
                    <Result
                        status="success"
                        title="Paiement reussi !"
                        subTitle={
                            <div>
                                <p>Vous etes maintenant inscrit a la formation :</p>
                                <p style={{ fontWeight: 700, color: C.blueDark, fontSize: 18 }}>
                                    {training.title}
                                </p>
                                <p style={{ color: '#6b7280', fontSize: 14, marginTop: 16 }}>
                                    Un email de confirmation avec le lien de la session a ete envoye.
                                </p>
                                <p style={{ color: '#9ca3af', fontSize: 13, marginTop: 12 }}>
                                    Redirection en cours...
                                </p>
                            </div>
                        }
                        extra={
                            <Button
                                type="primary"
                                size="large"
                                onClick={() => navigate(`/live-training/${id}`)}
                                style={{
                                    background: `linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%)`,
                                    border: 'none',
                                    fontWeight: 600,
                                    boxShadow: `0 4px 12px ${C.orange}66`,
                                }}
                            >
                                Voir ma formation
                            </Button>
                        }
                    />
                </div>
            </div>
        );
    }

    const timeUntil = getTimeUntil(training.liveDate);

    return (
        <div style={{
            minHeight: '100vh',
            background: '#f8f9fa',
            padding: '24px 16px',
        }}>
            <div style={{
                maxWidth: 1300,
                margin: '0 auto',
            }}>
                <Button
                    icon={<ArrowLeftOutlined />}
                    onClick={() => navigate(`/live-training/${id}`)}
                    size="large"
                    style={{
                        marginBottom: 24,
                        borderColor: C.blue,
                        color: C.blue,
                    }}
                >
                    Retour a la formation
                </Button>

                {/* HEADER BLEU NOMIDYA */}
                <div style={{
                    background: `linear-gradient(135deg, ${C.blueDeep} 0%, ${C.blueDark} 50%, ${C.blue} 100%)`,
                    borderRadius: 20,
                    padding: '32px',
                    color: 'white',
                    marginBottom: 24,
                    boxShadow: `0 8px 24px rgba(0,84,166,0.25)`,
                    position: 'relative',
                    overflow: 'hidden',
                }}>
                    {/* Décoration */}
                    <div style={{
                        position: 'absolute',
                        top: 0, left: 0,
                        width: '100%', height: '100%',
                        backgroundImage: `radial-gradient(circle at 80% 20%, ${C.orange}33 0%, transparent 50%)`,
                        pointerEvents: 'none',
                    }} />

                    <div style={{ position: 'relative', zIndex: 1 }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 16,
                            marginBottom: 16,
                        }}>
                            <div style={{
                                background: `linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%)`,
                                borderRadius: 12,
                                padding: 12,
                                fontSize: 32,
                                boxShadow: `0 4px 12px ${C.orange}66`,
                            }}>
                                <VideoCameraOutlined />
                            </div>
                            <div style={{ flex: 1 }}>
                                <div style={{
                                    fontSize: 13,
                                    opacity: 0.9,
                                    fontWeight: 600,
                                    textTransform: 'uppercase',
                                    letterSpacing: 1.5,
                                    color: C.orangeLight,
                                }}>
                                    Inscription Formation Live
                                </div>
                                <h1 style={{
                                    margin: '4px 0 0 0',
                                    fontSize: 28,
                                    fontWeight: 800,
                                }}>
                                    {training.title}
                                </h1>
                            </div>

                            {/* Compte a rebours dans le header - Orange */}
                            {timeUntil && (
                                <div style={{
                                    background: `linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%)`,
                                    padding: '12px 20px',
                                    borderRadius: 12,
                                    textAlign: 'center',
                                    boxShadow: `0 4px 12px ${C.orange}66`,
                                }}>
                                    <div style={{ fontSize: 11, fontWeight: 600, opacity: 0.95 }}>
                                        DEMARRAGE DANS
                                    </div>
                                    <div style={{ fontSize: 22, fontWeight: 800, marginTop: 4 }}>
                                        {timeUntil.days}j {timeUntil.hours}h
                                    </div>
                                </div>
                            )}
                        </div>

                        <div style={{
                            display: 'flex',
                            gap: 24,
                            flexWrap: 'wrap',
                            marginTop: 20,
                            paddingTop: 20,
                            borderTop: '1px solid rgba(255,255,255,0.2)',
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <CalendarOutlined />
                                <span>{formatDate(training.liveDate)}</span>
                            </div>
                            {training.duration && (
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                    <ClockCircleOutlined />
                                    <span>Duree : {training.duration}</span>
                                
                                </div>
                            )}
                            {/* <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <DollarOutlined style={{ color: C.orangeLight }} />
                                <span style={{ fontWeight: 700, fontSize: 18, color: C.orangeLight }}>
                                    {training.price?.toFixed(2)} $ CAD
                                </span>
                            </div> */}
                        </div>
                    </div>
                </div>

                {/* GRID 2 colonnes */}
                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 380px',
                        gap: 24,
                    }}
                    className="checkout-grid"
                >
                    {/* COMPOSANT MONERIS */}
                    <div>
                        <div style={{
                            background: 'white',
                            borderRadius: 16,
                            padding: 24,
                            boxShadow: '0 4px 16px rgba(0,84,166,0.08)',
                        }}>
                            <MonerisPaymentLiveTraining
                                liveTraining={training}
                                onSuccess={handleSuccess}
                                onError={handleError}
                            />
                        </div>
                    </div>

                    {/* SIDEBAR */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>

                        {/* Récap commande */}
                        <div style={{
                            background: 'white',
                            borderRadius: 16,
                            padding: 24,
                            boxShadow: '0 4px 16px rgba(0,84,166,0.08)',
                            border: '1px solid #f0f0f0',
                        }}>
                            <h3 style={{
                                fontSize: 12,
                                color: C.blueDark,
                                textTransform: 'uppercase',
                                letterSpacing: 1,
                                fontWeight: 700,
                                margin: '0 0 16px',
                                paddingBottom: 12,
                                borderBottom: '2px solid #f0f7ff',
                            }}>
                                📋 Recapitulatif de commande
                            </h3>

                            {training.image && (
                                <img
                                    src={training.image}
                                    alt={training.title}
                                    style={{
                                        width: '100%',
                                        height: 140,
                                        objectFit: 'cover',
                                        borderRadius: 10,
                                        marginBottom: 16,
                                    }}
                                />
                            )}

                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                padding: '8px 0',
                                borderBottom: '1px solid #f0f0f0',
                                fontSize: 14,
                            }}>
                                <span style={{ color: '#6b7280' }}>Formation :</span>
                                <span style={{
                                    fontWeight: 600,
                                    maxWidth: 200,
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                }}>
                                    {training.title}
                                </span>
                            </div>

                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                padding: '8px 0',
                                borderBottom: '1px solid #f0f0f0',
                                fontSize: 14,
                            }}>
                                <span style={{ color: '#6b7280' }}>Date :</span>
                                <span style={{ fontWeight: 600, textAlign: 'right' }}>
                                    {dayjs(training.liveDate).format('DD/MM/YYYY HH:mm')}
                                </span>
                            </div>

                            {training.duration && (
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    padding: '8px 0',
                                    borderBottom: '1px solid #f0f0f0',
                                    fontSize: 14,
                                }}>
                                    <span style={{ color: '#6b7280' }}>Duree :</span>
                                    <span style={{ fontWeight: 600 }}>{training.duration}</span>
                                </div>
                            )}

                            {training.category?.libelle && (
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    padding: '8px 0',
                                    borderBottom: '1px solid #f0f0f0',
                                    fontSize: 14,
                                }}>
                                    <span style={{ color: '#6b7280' }}>Categorie :</span>
                                    <span style={{ fontWeight: 600, color: C.blue }}>{training.category.libelle}</span>
                                </div>
                            )}

                            {/* TOTAL - ORANGE */}
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '16px 0 8px',
                                marginTop: 8,
                                borderTop: `2px solid ${C.orange}`,
                            }}>
                                <span style={{ fontSize: 16, fontWeight: 700 }}>Total :</span>
                                <span style={{
                                    color: C.orange,
                                    fontWeight: 800,
                                    fontSize: 26,
                                }}>
                                    {training.price?.toFixed(2)} $ CAD
                                </span>
                            </div>
                        </div>

                        {/* Vos informations */}
                        <div style={{
                            background: 'white',
                            borderRadius: 16,
                            padding: 24,
                            boxShadow: '0 4px 16px rgba(0,84,166,0.08)',
                            border: '1px solid #f0f0f0',
                        }}>
                            <h3 style={{
                                fontSize: 12,
                                color: C.blueDark,
                                textTransform: 'uppercase',
                                letterSpacing: 1,
                                fontWeight: 700,
                                margin: '0 0 16px',
                                paddingBottom: 12,
                                borderBottom: '2px solid #f0f7ff',
                            }}>
                                👤 Vos informations
                            </h3>

                            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
                                <UserOutlined style={{ color: C.blue, fontSize: 16 }} />
                                <div>
                                    <div style={{ fontSize: 11, color: '#9ca3af', textTransform: 'uppercase' }}>
                                        Utilisateur
                                    </div>
                                    <div style={{ fontWeight: 600 }}>{currentUser?.username}</div>
                                </div>
                            </div>

                            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                <MailOutlined style={{ color: C.blue, fontSize: 16 }} />
                                <div>
                                    <div style={{ fontSize: 11, color: '#9ca3af', textTransform: 'uppercase' }}>
                                        Email de contact
                                    </div>
                                    <div style={{ fontWeight: 600, fontSize: 13 }}>{currentUser?.email}</div>
                                </div>
                            </div>
                        </div>

                        {/* Avantages inclus - ORANGE NOMIDYA */}
                        <div style={{
                            background: `linear-gradient(135deg, ${C.orange}11 0%, ${C.orangeLight}22 100%)`,
                            borderRadius: 16,
                            padding: 24,
                            border: `1px solid ${C.orange}44`,
                        }}>
                            <h3 style={{
                                fontSize: 12,
                                color: C.orangeDark,
                                textTransform: 'uppercase',
                                letterSpacing: 1,
                                fontWeight: 800,
                                margin: '0 0 16px',
                            }}>
                                <GiftOutlined /> Avantages inclus
                            </h3>

                            <ul style={{
                                listStyle: 'none',
                                padding: 0,
                                margin: 0,
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 10,
                            }}>
                                <li style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13, color: '#1a1a1a' }}>
                                    <CheckCircleOutlined style={{ color: '#10b981', fontSize: 16, marginTop: 2 }} />
                                    <span>Session live interactive avec le formateur</span>
                                </li>
                                <li style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13, color: '#1a1a1a' }}>
                                    <CheckCircleOutlined style={{ color: '#10b981', fontSize: 16, marginTop: 2 }} />
                                    <span>Q&A en direct pour poser vos questions</span>
                                </li>
                                <li style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13, color: '#1a1a1a' }}>
                                    <CheckCircleOutlined style={{ color: '#10b981', fontSize: 16, marginTop: 2 }} />
                                    <span>Lien meeting envoye par email</span>
                                </li>
                                <li style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13, color: '#1a1a1a' }}>
                                    <CheckCircleOutlined style={{ color: '#10b981', fontSize: 16, marginTop: 2 }} />
                                    <span>Rappels automatiques avant le live</span>
                                </li>
                                <li style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13, color: '#1a1a1a' }}>
                                    <CheckCircleOutlined style={{ color: '#10b981', fontSize: 16, marginTop: 2 }} />
                                    <span>Replay disponible apres la session</span>
                                </li>
                                <li style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13, color: '#1a1a1a' }}>
                                    <CheckCircleOutlined style={{ color: '#10b981', fontSize: 16, marginTop: 2 }} />
                                    <span>Support du formateur 7 jours</span>
                                </li>
                            </ul>
                        </div>

                        {/* Garanties de sécurité - BLEU */}
                        <div style={{
                            background: 'white',
                            borderRadius: 16,
                            padding: 20,
                            border: `1px solid ${C.blue}33`,
                            boxShadow: '0 4px 16px rgba(0,84,166,0.08)',
                        }}>
                            <h3 style={{
                                fontSize: 12,
                                color: C.blueDark,
                                textTransform: 'uppercase',
                                letterSpacing: 1,
                                fontWeight: 700,
                                margin: '0 0 16px',
                                paddingBottom: 12,
                                borderBottom: '2px solid #f0f7ff',
                            }}>
                                🛡️ Paiement securise
                            </h3>

                            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                    <LockOutlined style={{ color: '#10b981', fontSize: 18 }} />
                                    <div style={{ fontSize: 13 }}>
                                        <strong>Chiffrement SSL/TLS</strong>
                                        <div style={{ fontSize: 11, color: '#9ca3af' }}>
                                            Vos donnees sont protegees
                                        </div>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                    <SafetyCertificateOutlined style={{ color: '#10b981', fontSize: 18 }} />
                                    <div style={{ fontSize: 13 }}>
                                        <strong>Norme PCI-DSS</strong>
                                        <div style={{ fontSize: 11, color: '#9ca3af' }}>
                                            Standard bancaire
                                        </div>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                    <CheckCircleOutlined style={{ color: '#10b981', fontSize: 18 }} />
                                    <div style={{ fontSize: 13 }}>
                                        <strong>Powered by Moneris</strong>
                                        <div style={{ fontSize: 11, color: '#9ca3af' }}>
                                            Leader canadien
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Aide - BLEU NOMIDYA */}
                        <div style={{
                            background: `linear-gradient(135deg, ${C.blue}11 0%, ${C.blueDark}11 100%)`,
                            border: `1px solid ${C.blue}44`,
                            borderRadius: 12,
                            padding: 16,
                            textAlign: 'center',
                        }}>
                            <div style={{ fontSize: 12, color: C.blueDark, fontWeight: 600, marginBottom: 4 }}>
                                💬 Besoin d'aide ?
                            </div>
                            <div style={{ fontSize: 13, color: C.blue, fontWeight: 700 }}>
                                +212 661 571 360
                            </div>
                            <div style={{ fontSize: 11, color: '#6b7280', marginTop: 4 }}>
                                Disponible 7j/7
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div style={{
                    textAlign: 'center',
                    marginTop: 32,
                    color: '#6b7280',
                    fontSize: 13,
                }}>
                    <CheckCircleOutlined style={{ color: '#10b981', marginRight: 6 }} />
                    Paiement 100% securise par Moneris
                </div>

                <style>{`
                    @media (max-width: 1024px) {
                        .checkout-grid {
                            grid-template-columns: 1fr !important;
                        }
                    }
                `}</style>
            </div>
        </div>
    );
};

export default MonerisLiveTrainingCheckoutPage;
